import * as React from 'react';
import { styled } from '../../theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface BreadCrumbWidgetProps {
  steps: string[];
  currentStep: number;
  className?: string;
}

export const BreadCrumbWidget: React.FC<BreadCrumbWidgetProps> = (props) => {
  return (
    <S.Container className={props.className}>
      {props.steps.map((step, index) => {
        if (index < props.steps.length - 1) {
          return (
            <S.Step futureStep={index > props.currentStep} key={index} currentStep={props.currentStep === index}>
              {step}
              <S.Icon icon="angle-right" />
            </S.Step>
          );
        } else {
          return (
            <S.Step futureStep={index > props.currentStep} key={index} currentStep={props.currentStep === index}>
              {step}
            </S.Step>
          );
        }
      })}
    </S.Container>
  );
};

namespace S {
  export const Container = styled.div`
    font-size: 18px;
    text-align: center;
    color: ${(p) => p.theme.text.secondary};
    margin-top: 12px;
    margin-bottom: 18px;
    display: flex;
  `;

  export const Step = styled.div<{ currentStep: boolean; futureStep: boolean }>`
    font-weight: ${(props) => (props.currentStep ? 'bold' : 'normal')};
    display: inline-flex;
    float: left;
    height: auto;
    vertical-align: text-bottom;
    margin: auto;
    align-items: center;
    opacity: ${(p) => (p.futureStep ? 0.5 : 1)};
  `;

  export const Icon = styled(FontAwesomeIcon)`
    margin-left: 12px;
    margin-right: 12px;
    height: 20px;
  `;
}
